import { tempoApi } from '@/common/api/tempoApi';

export interface DependencyResponse {
  id: number;
  predecessorId: number;
  successorId: number;
  waitDays: number | null;
}

interface DependencyRequest {
  itemId: number;
  predecessorId?: number;
  successorId?: number;
}

const createDependency = async ({
  itemId,
  predecessorId,
  successorId,
}: DependencyRequest): Promise<DependencyResponse> =>
  await tempoApi()
    .post(`api/v1/item-store/items/${itemId}/dependencies`, {
      json: { predecessorId, successorId },
    })
    .json<DependencyResponse>();

const deleteDependency = async ({
  itemId,
  predecessorId,
  successorId,
}: DependencyRequest): Promise<void> => {
  await tempoApi().delete(`api/v1/item-store/items/${itemId}/dependencies`, {
    json: { predecessorId, successorId },
  });
};

export const DependenciesApi = {
  createDependency,
  deleteDependency,
};
